import styled from 'styled-components'
import { colors, updatedMedia } from 'client/styles'

import { DatePickerBase } from 'client/components/DatePicker/styles'
import { DateSelectorBase } from 'client/components/DateSelector/styles'
import { PaxSelectorBase } from 'client/components/PaxSelector/styles'
import { Label } from 'client/components/InputReadOnly/styles'
import { LoaderBase } from 'src/comps/Atom/Loader/styles'

export const Paxes = styled.div`
  background-color: ${colors.white};
  border-radius: 8px;
  border: 2px solid;
  border-color: ${props => (props.isFocus ? colors.grey1 : colors.grey4)};

  ${updatedMedia.tablet} {
    position: relative;

    & ${PaxSelectorBase} {
      position: absolute;
      inset-block-start: calc(100% + 10px);
      inset-inline-start: 0;
      width: 375px;
      background-color: ${colors.white};
      padding-block-end: 0;
    }
  }

  ${updatedMedia.desktop} {
    &:hover {
      border-color: ${colors.grey1};
    }
  }

  ${Label} {
    padding-block: 6px;
    padding-inline: 12px;
  }

  ${LoaderBase} {
    position: absolute;
    inset-block-start: 40px;
    inset-inline-start: 50%;
    transform: translateX(calc(var(--transform-direction) * -50%));
  }
`

export const Form = styled.form`
  display: grid;
  gap: 20px;
  width: 100%;

  ${updatedMedia.tablet} {
    align-items: stretch;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr auto;
  }

  ${updatedMedia.desktop} {
    ${DateSelectorBase} {
      flex: 0 0 308px;
    }
  }
`

export const RoomsUpdaterBase = styled.div`
  margin-inline: auto;
  margin-block: 0;

  h2 {
    color: ${colors.grey1};
    font-size: 21px;
    font-weight: 700;
    line-height: 1.2;
    margin-block-end: 20px;
    ${updatedMedia.tablet} {
      font-size: 28px;
    }
  }

  ${DateSelectorBase} > div {
    border-radius: 64px;
  }

  ${Paxes} {
    border-radius: 64px;
  }

  ${updatedMedia.tablet} {
    ${Form} {
      display: inline-flex;
      justify-content: space-between;
      gap: 0px;
    }

    ${DateSelectorBase} {
      flex: 0 0 49%;
      margin-inline-end: 0;

      ${DatePickerBase} {
        inset-inline-start: 0;
      }
    }

    ${Paxes} {
      flex: 0 0 49%;
      margin-inline-end: 0;
    }
  }
`
